import ContentLoader, { Rect } from "react-content-loader/native";
import React from "react";
import { ViewStyle } from "react-native";

/* Adjust the width and height to set the size of the loader */
/* Use the style prop for margin/padding */
/* Use the radius prop to set the border radius */

type Props = {
  width?: string | number;
  height?: string | number;
  radius?: number;
  style?: ViewStyle;
};

const RectangleLoader: React.FC<Props> = ({
  width = 50,
  height = 20,
  style,
  radius = 3,
}) => {
  return (
    <ContentLoader
      speed={2}
      width={width}
      height={height}
      backgroundColor="#e8e8eb"
      foregroundColor="#aeaeb2"
      style={style}
    >
      <Rect width={width} height={height} rx={radius} ry={radius} />
    </ContentLoader>
  );
};

export default RectangleLoader;
